import { render, staticRenderFns } from "./NewMachine.vue?vue&type=template&id=73b2c592"
import script from "./NewMachine.vue?vue&type=script&lang=ts"
export * from "./NewMachine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/apps/front/flightpath-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73b2c592')) {
      api.createRecord('73b2c592', component.options)
    } else {
      api.reload('73b2c592', component.options)
    }
    module.hot.accept("./NewMachine.vue?vue&type=template&id=73b2c592", function () {
      api.rerender('73b2c592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewMachine.vue"
export default component.exports